import {
  isPlainObject,
  get,
  isUndefined,
  isNull,
  isArray,
  set,
  isString,
} from 'lodash'
import i18n from '@/react-i18next-config'
import { LANGUAGE_KEY_EN, LANGUAGE_MAP } from '@/common/language'
import { fetchVersion } from '@/services/version'

/**
 * 将对象转换为URLEncoded字符串
 * @param obj
 * @returns {string}
 */
export function objectToUrlEncoded(obj: { [key: string]: any }) {
  const str = []
  const keys = Object.keys(obj)
  for (const key of keys) {
    str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
  }
  return str.join('&')
}

export const getUrlQueryString = (name: string) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return decodeURIComponent(r[2])
  }
  return null
}
/**
 * 将接口返回数据的首字母改为小写
 * @param obj
 * @returns
 */
export const parseObjectFirstTextLowerCase = <T1 extends object>(obj: T1) => {
  if (!isPlainObject(obj)) {
    return obj
  }
  const objNewItem = {} as T1
  Object.keys(obj).forEach((oldKey: string) => {
    const newkey = oldKey.replace(oldKey[0], oldKey[0].toLowerCase())
    const value = get(obj, [oldKey])
    let newValue: typeof value =
      isNull(value) || isUndefined(value) ? null : value
    if (isArray(value)) {
      newValue = value.map(item => parseObjectFirstTextLowerCase(item))
    } else if (isPlainObject(value)) {
      newValue = parseObjectFirstTextLowerCase(value)
    }
    set(objNewItem, [newkey], newValue)
  })
  return objNewItem
}

export function parseApiUrl(url: string, fromWebsocket?: boolean): string {
  const { env = '' } = window
  let api = env
  if (fromWebsocket) {
    const [newApi] = env.split('api/') || []
    api = newApi
  }
  return `${api}${url}`
}

export function getLangKey(): string {
  const language = get(LANGUAGE_MAP, i18n.language) || LANGUAGE_KEY_EN
  return language
}

/**
 * 获取git版本
 * @returns {*}
 */
function getGitVersion() {
  return window.VERSION
}

/**
 * 设置git版本
 * @returns {*}
 */
function setGitVersion(version: string) {
  window.VERSION = version
}

/**
 * 检查版本是否是最新的
 * @returns {Promise<void>}
 */
// eslint-disable-next-line consistent-return
const hasNewVersion = async () => {
  try {
    const newVersion = await fetchVersion()
    if (!isString(newVersion) || !newVersion) {
      return false
    }

    const prevVersion = getGitVersion()
    if (!prevVersion) {
      setGitVersion(newVersion)
    } else if (prevVersion !== newVersion) {
      return true
    }
  } catch (err) {
    console.error(err, 'hasNewVersion')
  }
}

/**
 * 检查版本是否更新
 */
export async function checkVersion() {
  await hasNewVersion()
  window.setInterval(async () => {
    const hasVersionChanged = await hasNewVersion()
    if (hasVersionChanged) {
      try {
        await window.fetch('/')
        window.location.reload()
      } catch (err) {
        console.error(err, 1)
      }
    }
  }, 10 * 1000)
}

export const getUrlParams = () => {
  const url = window.location.href

  // Extract the query string from the URL
  const queryString = get(url.split('?'), [1]) || ''

  // Split the query string into individual parameters
  const paramsArray = queryString ? queryString.split('&') : []

  // Create an object to store the parameter key-value pairs
  const params: Record<string, string> = {}

  // Loop through the parameters and populate the object
  paramsArray.forEach((param: any) => {
    let keyValue = param.split('=')
    let key = decodeURIComponent(keyValue[0])
    let value = decodeURIComponent(keyValue[1])
    params[key] = value
  })
  return params
}
